import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AuthenticatedRoute = () => {
  const user = localStorage.getItem('user');
  let parsedUser = null;

  if (user) {
    try {
      parsedUser = JSON.parse(user);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return <Navigate to="/login" />;
    }
  }

  if (parsedUser) {
    switch (parsedUser.role) {
      case 'Head Office Admin':
        return <Navigate to="/admin/dashboard" />;
      case 'Regional Manager':
        return <Navigate to="/coordinator/dashboard" />;
      case 'Content Editor':
        return <Navigate to="/editor/dashboard" />;
      case 'Content Reviewer':
        return <Navigate to="/approver/dashboard" />;
      case 'Trainer':
        return <Navigate to="/branch/dashboard" />;
      default:
        return <Navigate to="/login" />;
    }
  }

  return <Outlet />;
};

export default AuthenticatedRoute;